import "./index.scss";
import classnames from "classnames";
import {useTranslation} from "react-i18next";

interface iItem {
  value: string;
  pathname: string;
  name?: string;
  _id?: string | number;
}
type Props = {
  tabs: iItem[];
  onClick: (props: iItem) => void;
  selected: iItem;
};

const SubTabs = ({ tabs, onClick, selected }: Props) => {

  const { t } = useTranslation();

  return (
    <div id="sub-tab-container">
      {tabs.map((tab, index) => {
        return (
          <div
            onClick={() => onClick(tab)}
            key={`tab-${tab.value}-${index}`}
            className={classnames("sub-tab-item", {
              selectedTab: selected?.pathname === tab?.pathname,
            })}
          >
            <h4>{t(tab.value)}</h4>
          </div>
        );
      })}
    </div>
  );
};

export default SubTabs;
